export default __webpack_public_path__ + "static/media/PDF.54e0cc8f.svg";